export default function (userInputs, labels, store, adultPrice, childPrice) {
    const deltagere = userInputs.adults
    const childDeltagere = userInputs.children

    const basket = []

    basket.push({
        label: labels.yourInformationTotalNewAdultDeltagereLabel,
        amount: `${deltagere.length} ${labels.yourInformationTotalDeltagereLabel} (á ${adultPrice} kr.)`,
        price: `${deltagere.length * adultPrice} kr.`,
        intPrice: deltagere.length * adultPrice
    })

    basket.push({
        label: labels.yourInformationTotalNewChildDeltagereLabel,
        amount: `${childDeltagere.length} ${labels.yourInformationTotalDeltagereLabel} (á ${childPrice} kr.)`,
        price: `${childDeltagere.length * childPrice} kr.`,
        intPrice: childDeltagere.length * childPrice
    })

    store.dispatch('stafet/basket', { basket: basket })
}
